import { type FC } from 'react'

import { DirectContactFormImageUploadField } from '../DirectContactFormImageUploadField/DirectContactFormImageUploadField'

import { DirectContactFormDoctorOrderNotification } from './DirectContactFormDoctorOrderNotification'

export const DirectContactFormHookFormDialogDoctorOrderFields: FC<{
  isDoctorOrder: boolean
  isLoggedIn: boolean
}> = ({ isDoctorOrder, isLoggedIn }) => {
  if (!isDoctorOrder) {
    return null
  }

  return (
    <>
      <DirectContactFormDoctorOrderNotification isLoggedIn={isLoggedIn} />
      {isLoggedIn ? (
        <DirectContactFormImageUploadField isMandatory={false} />
      ) : null}
    </>
  )
}
